import {
	makeNodeName,
} from '~/components/ktable/utils';
import {
	BaseController,
} from '~/utils/base-controller';

/**
 * @implements {angular.IController}
 */
export default class KtableSettings extends BaseController {
	// bindings
	widget;

	/** @type {Dashboard.KTableWidgetOptionsOptions} */
	settings

	parent

	/* @ngInject */
	// eslint-disable-next-line no-useless-constructor
	constructor(
		$injector,
	) {
		super($injector);

		this.sortTypes = [{
			title: 'Croissant',
			value: 'ASC',
		},
		{
			title: 'Décroissant',
			value: 'DESC',
		},
		];

		/** @type {{title: string, value: Ktable.Visibility['visibility']}[]} */
		this.visibilityType = [{
			title: 'Visible',
			value: 'visible',
		},
		{
			title: 'Invisible',
			value: 'hidden',
		},
		];

		const numbers = [
			'K_NODE;NUMBER',
			'K_NODE;INTEGER',
			'K_NODE;FLOAT',
			'K_NODE;DOUBLE',
		];

		const strings = [
			'K_NODE;STRING',
			'K_NODE;TEXT',
		];

		const virtual = 'virtual';

		this.binding = [{
			allow: [],
			value: null,
			title: 'Aucun',
		},
		{
			allow: [
				...numbers,
				virtual,
			],
			value: 'sum',
			title: 'Somme',
		},
		{
			allow: [
				...numbers,
				virtual,
			],
			value: 'avg',
			title: 'Moyenne',
		},
		{
			allow: [
				...numbers,
				virtual,
			],
			value: 'min',
			title: 'Minimum',
		},
		{
			allow: [
				...numbers,
				virtual,
			],
			value: 'max',
			title: 'Maximum',
		},
		{
			allow: [...strings, ...numbers, virtual],
			value: 'notEmpty',
			title: 'Non vide',
		},
		];

		this.settings = {
			sorts: [],
			calculation: [],
			visibility: [],
		};

		this.query = [];

		this.tab = 'calculations';
	}

	/**
	 *
	 * @param {string} columnId
	 */
	calculationTypes(columnId) {
		if (!columnId) {
			return [];
		}

		const column = this.query.find(c => c.id === columnId);

		let {
			type,
		} = column;
		const {
			op,
		} = column;

		if (op === 'count') {
			type = 'K_NODE;NUMBER';
		}

		if (column.type && column) {
			return this.binding.filter(b => b.allow.length === 0 || b.allow.includes(type));
		}

		throw new Error('Column not found');
	}

	makeNodeName(column) {
		return makeNodeName(column, this.$translate);
	}

	$onInit() {
		if (this.widget?.options?.data) {
			this.settings = {
				...this.widget.options.data,
			};

			if (!this.settings.calculation || !Array.isArray(this.settings.calculation)) {
				this.settings.calculation = [];
			}

			if (!this.settings.visibility || !Array.isArray(this.settings.visibility)) {
				this.settings.visibility = this.query.map(c => {
					/** @type {Ktable.Visibility} */
					const visibility = {
						column: c.id,
						visibility: 'visible',
					};
					return visibility;
				});
			}
		}

		this.parent.widgetData = this.settings;

		this.query = this.widget.query.select;

		// eslint-disable-next-line no-console
		console.log('this.settings', this.settings);
		// eslint-disable-next-line no-console
		console.log('this.query', this.query);
	}

	addSortLine() {
		this.settings.sorts.push({
			value: null,
			type: 'ASC',
		});
	}

	addCalcLine() {
		this.settings.calculation.push({
			column: null,
			type: null,
		});
	}

	addVisibilityLine() {
		this.settings.visibility.push({
			column: null,
			visibility: 'visible',
		});
	}

	removeSortLine(index) {
		this.settings.sorts.splice(index, 1);
	}

	removeCalcLine(index) {
		this.settings.calculation.splice(index, 1);
	}

	removeVisibilityLine(index) {
		this.settings.visibility.splice(index, 1);
	}

	getErrors() {
		const failures = [];
		const warnings = [];

		// TODO: check if multiple sorts on the same column

		this.parent.isValid = failures.length === 0;

		return [...failures, ...warnings];
	}

	errorCount() {
		return this.getErrors().length;
	}

	getErrorsAsString() {
		return this.getErrors().join(', ');
	}
}
